<script lang="ts">
import { templateRef, useEventListener, useMouseInElement, useVModel } from '@vueuse/core'
import { defineComponent, ref, watch } from 'vue'

export default defineComponent({
  name: 'VideoPlayerProgress',
  components: {},
  props: {
    max: { type: Number, default: 100 },
    progress: { type: Number, default: 0 },
    modelValue: { type: Number, required: true }
  },
  emits: ['update:modelValue'],
  setup (props, { expose, emit }) {
    const elScrubber = templateRef('elScrubber')
    const scrubbing = ref(false)
    const pendingValue = ref(0)

    const value = useVModel(props, 'modelValue', emit)
    const { elementX, elementWidth } = useMouseInElement(elScrubber)

    watch([scrubbing, elementX], () => {
      const barProgress = Math.max(0, Math.min(1, (elementX.value) / elementWidth.value))
      pendingValue.value = barProgress * props.max
      if (scrubbing.value) { value.value = pendingValue.value }
    })

    useEventListener('mouseup', () => (scrubbing.value = false))

    return {
      scrubbing
    }
  }
})
</script>

<template>
  <div
    ref="elScrubber"
    class="progress cursor-pointer select-none"
    @mousedown="scrubbing = true"
  />
</template>

<style lang="scss" scoped>
.progress {
  position: relative;
  height: 8px;
  background-color: color('grey-dark');

  &::before {
    position: absolute;
    display: block;
    background-color: color('blue');
    content: '';
    inset: 0;
    transform: scaleX(v-bind(progress));
    transform-origin: center left;
    transition: transform 0.1s;

    @include motion-reduce {
      transition-duration: 0s;
    }
  }
}
</style>
